// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"89eda9f0","963":"95e9ba9c"}[chunkId] + ".chunk.js";
};